import { ActionContext, ActionTree } from 'vuex';
import { StateInterface } from '../index';
import { UserInterface } from 'src/store/user/state';

const actions: ActionTree<UserInterface, StateInterface> = {
  setUser(
    context: ActionContext<UserInterface, StateInterface>,
    user: Record<string, unknown>
  ) {
    context.commit('SET_USER', user);
  },

  setTasks(context: ActionContext<UserInterface, StateInterface>, tasks: []) {
    context.commit('SET_TASKS', tasks);
  },

  addTasks(context: ActionContext<UserInterface, StateInterface>, tasks: []) {
    context.commit('ADD_TASKS', tasks);
  },
};

export default actions;
